<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body with Loader -->
@if (showEntityLoader) {
<div class="modal-body" [hidden]="minimise">
  <div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
</div>
}

<!-- Modal Body with Form -->
@if (!showEntityLoader) {
<div class="modal-body" [hidden]="minimise">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4><b>Include / Exclude LE in Form 851:</b></h4>
    </div>
    <div class="panel-body">
      <!-- Row 1: Legal Entity, Form Category, Filing Key -->
      <div class="form-row">
        <div class="form-col-4">
          <div class="form-group">
            <label for="legalEntity"><b>Legal Entity<sup>*</sup>:</b></label>
            <input 
              type="text" 
              class="form-control" 
              id="legalEntity" 
              name="legalEntity"
              [(ngModel)]="exclusionEntity.LEGAL_ENTITY_ID"
              (ngModelChange)="upper($event)"
              [disabled]="isEdit === 'UPDATE'">
            @if (validationErrors.LEGAL_ENTITY_ID_NOT_VALID && !exclusionEntity.LEGAL_ENTITY_ID) {
<small class="text-danger" 
                  >
              Please provide Legal Entity
            </small>
}
          </div>
        </div>
        
        <div class="form-col-4">
          <div class="form-group">
            <label for="formCategory"><b>Form Category<sup>*</sup>:</b></label>
            <select 
              class="form-control" 
              id="formCategory" 
              name="formCategory"
              [(ngModel)]="exclusionEntity.FORM_CATEGORY">
              <option value="851" selected>851</option>
            </select>
            @if (validationErrors.FORM_CATEGORY_NOT_VALID && !exclusionEntity.FORM_CATEGORY) {
<small class="text-danger" 
                  >
              Please provide Form Category
            </small>
}
          </div>
        </div>
        
        <div class="form-col-4">
          <div class="form-group">
            <label for="filingKey"><b>Filing Key<sup>*</sup>:</b></label>
            <select 
              class="form-control" 
              id="filingKey" 
              name="filingKey"
              [(ngModel)]="exclusionEntity.FILING_KEY">
              @for (item of consolGroups; track itemTracker($index, item)) {
<option 
                      [value]="item.VALUE">{{ item.LABEL }}</option>
}
            </select>
            @if (validationErrors.FILING_KEY_NOT_VALID && !exclusionEntity.FILING_KEY) {
<small class="text-danger" 
                  >
              Please provide Filing Key
            </small>
}
          </div>
        </div>
      </div>

      <!-- Row 2: Start Tax Year, End Tax Year -->
      <div class="form-row">
        <div class="form-col-6">
          <div class="form-group">
            <label for="start-tax-year"><b>Start Tax Year<sup>*</sup>:</b></label>
            <p class="input-group">
              <input 
                type="number" 
                class="form-control" 
                id="start-tax-year" 
                name="start-tax-year"
                [(ngModel)]="startTaxYear"
                min="1900"
                max="9999"
                placeholder="YYYY"
                [disabled]="isEdit === 'UPDATE'"
                readonly>
              @if (isEdit !== 'UPDATE') {
<span class="input-group-addon" 
                   
                    (click)="openStartYearPicker(); $event.stopPropagation()"
                    style="cursor: pointer;">
                <i class="glyphicon glyphicon-calendar"></i>
              </span>
}
              @if (isEdit === 'UPDATE') {
<span class="input-group-addon" 
                   
                    style="cursor: not-allowed; opacity: 0.65;">
                <i class="glyphicon glyphicon-calendar"></i>
              </span>
}
            </p>
            
            <!-- Start Year Picker Popup -->
            @if (isEdit !== 'UPDATE') {
<gtw-year-picker-popup
             
              [selectedYear]="startTaxYear"
              [showPopup]="showStartYearPicker"
              [minYear]="1900"
              [maxYear]="9999"
              [triggerElementId]="'start-tax-year'"
              (yearSelected)="onStartYearSelected($event)"
              (popupClosed)="closeStartYearPicker()">
            </gtw-year-picker-popup>
}
            
            @if (validationErrors.START_TAX_YEAR_NOT_VALID && !exclusionEntity.START_TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide Start Tax Year
            </small>
}
          </div>
        </div>
        
        <div class="form-col-6">
          <div class="form-group">
            <label for="end-tax-year"><b>End Tax Year<sup>*</sup>:</b></label>
            <p class="input-group">
              <input 
                type="number" 
                class="form-control" 
                id="end-tax-year" 
                name="end-tax-year"
                [(ngModel)]="endTaxYear"
                min="1900"
                max="9999"
                placeholder="YYYY"
                readonly>
              <span class="input-group-addon" 
                    (click)="openEndYearPicker(); $event.stopPropagation()"
                    style="cursor: pointer;">
                <i class="glyphicon glyphicon-calendar"></i>
              </span>
            </p>
            
            <!-- End Year Picker Popup -->
            <gtw-year-picker-popup
              [selectedYear]="endTaxYear"
              [showPopup]="showEndYearPicker"
              [minYear]="1900"
              [maxYear]="9999"
              [triggerElementId]="'end-tax-year'"
              (yearSelected)="onEndYearSelected($event)"
              (popupClosed)="closeEndYearPicker()">
            </gtw-year-picker-popup>
            
            @if (validationErrors.END_TAX_YEAR_NOT_VALID && !exclusionEntity.END_TAX_YEAR) {
<small class="text-danger" 
                  >
              Please provide To Year
            </small>
}
          </div>
        </div>
      </div>

      <!-- Row 3: Status, Status Comment -->
      <div class="form-row">
        <div class="form-col-6">
          <div class="form-group">
            <label for="status"><b>Status<sup>*</sup>:</b></label>
            <select 
              class="form-control" 
              id="status" 
              name="status"
              [(ngModel)]="exclusionEntity.STATUS">
              <option value="EXCLUDE" selected>EXCLUDE</option>
              <option value="INCLUDE">INCLUDE</option>
            </select>
            @if (validationErrors.STATUS_NOT_VALID && !exclusionEntity.STATUS) {
<small class="text-danger" 
                  >
              Please provide Status
            </small>
}
          </div>
        </div>
        
        <div class="form-col-6">
          <div class="form-group">
            <label for="statusComment"><b>Status Comment:</b></label>
            <input 
              type="text" 
              class="form-control" 
              id="statusComment" 
              name="statusComment"
              [(ngModel)]="exclusionEntity.STATUS_COMMENT">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    [disabled]="isSaveClicked" 
    (click)="save()">
    @if (isEdit === 'INSERT') {
<span>Create</span>
}
    @if (isEdit === 'UPDATE') {
<span>Update</span>
}
    @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
  </button>
  <button 
    class="reset-button" 
    type="button" 
    (click)="reset()">Reset</button>
  <button 
    class="button-cancel" 
    type="button" 
    (click)="cancel()">Cancel</button>
</div>

